import { useState, useEffect } from "react";

export function useIsMobile() {
  const [mobile, setMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setMobile(window.innerWidth < 768);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return mobile;
}

export function useIsDesktop() {
  const [desktop, setDesktop] = useState(window.innerWidth > 768);
  useEffect(() => {
    const fn = () => setDesktop(window.innerWidth > 768);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return desktop;
}
